<template>
<div id="sub-banner" :style="{ background: 'url(' + banner +') no-repeat center top'}" class="sub-banner parallax-background"  data-paroller-factor="-0.09" data-paroller-factor-sm="-0.09" data-paroller-factor-xs="-0.09">
  <div class="container">
    <div class="row"> 
      <div class="col-md-12">
          <div class="banner-description">
            <h1 v-html="title" class="white-c mar-no"></h1>
            <h6 v-html="tag" class="white-c mar-no font-light padd-t10"></h6>   
          </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'Subbanner',
  props: ['title','tag','banner']
}
</script>



// WEBPACK FOOTER //
// src/components/Subbanner.vue